import { Button } from "@/components/ui/button";
import { ExternalLink, Loader2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface CartFooterProps {
  totalPrice: number;
  currencyCode: string;
  isLoading: boolean;
  isDisabled: boolean;
  onCheckout: () => void;
}

export const CartFooter = ({ 
  totalPrice, 
  currencyCode, 
  isLoading, 
  isDisabled, 
  onCheckout 
}: CartFooterProps) => {
  const { t } = useLanguage();

  return (
    <div className="flex-shrink-0 space-y-4 pt-4 border-t bg-background">
      <div className="flex justify-between items-center">
        <span className="text-lg font-semibold">{t("Total", "Total")}</span>
        <span className="text-xl font-bold" aria-label={`Total: ${currencyCode} ${totalPrice.toFixed(2)}`}>
          {currencyCode} ${totalPrice.toFixed(2)}
        </span>
      </div>
      
      <Button 
        onClick={onCheckout}
        className="w-full" 
        size="lg"
        disabled={isDisabled}
        aria-label={isLoading ? t("Creating Checkout...", "Creando Pago...") : t("Checkout with Shopify", "Pagar con Shopify")}
      >
        {isLoading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" aria-hidden="true" />
            {t("Creating Checkout...", "Creando Pago...")}
          </>
        ) : (
          <>
            <ExternalLink className="w-4 h-4 mr-2" aria-hidden="true" />
            {t("Checkout with Shopify", "Pagar con Shopify")}
          </>
        )}
      </Button>
    </div>
  );
};
